@if (!isLoading) {
  <div class="site-content">
    <app-sidebar-admin></app-sidebar-admin>
    <div class="content">
      <app-alert [adminArea]="true"></app-alert>
      <app-header-admin></app-header-admin>
      <router-outlet></router-outlet>
    </div>
  </div>
} @else {
  <div class="loading-wrapper">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="32">
    </mat-progress-spinner>
  </div>
}
